import React from "react";
import ReactDOM from "react-dom";

import App from "./App.jsx";
import "./index.css";
import "react-tooltip/dist/react-tooltip.css";
import "./i18n.js";

ReactDOM.render(<App />, document.getElementById("root"));
